export type CartItemIdParsed = {
  menuId: number;
  optionIds: number[];
};

export function parseCartItemId(id: string): CartItemIdParsed {
  const parts = id.split('-').map(Number);
  return {
    menuId: parts[0],
    optionIds: parts.slice(1).filter(n => !isNaN(n)),
  };
}

export type PriceChange = {
  id: string;
  name: string;
  oldPrice: number;
  newPrice: number;
  option?: string;
};
